import { useRouter } from 'next/router';

import { ErrorScreen } from '~/domains/common/components/ErrorScreen/ErrorScreen';
import { Button } from '~/domains/design-system/Button';

import { ErrorNote } from '../../components/ErrorNote';

export function SectionError({
  error,
  sectionKey,
  onRetry,
}: {
  error: unknown & { response: { status: number } };
  sectionKey: string;
  onRetry: () => void;
}) {
  const router = useRouter();

  if (error.response?.status === 404) {
    return (
      <ErrorScreen
        errorCode={404}
        title="Page not found"
        cta={[
          <Button
            size="medium"
            key="reload"
            onClick={() => {
              router.back();
            }}
          >
            Go back
          </Button>,
        ]}
      />
    );
  }

  return (
    <ErrorScreen
      title="Something went wrong"
      description="There was an error loading this section. Try reloading the page."
      cta={[
        <Button
          size="medium"
          key="reload"
          onClick={() => {
            router.reload();
          }}
        >
          Reload the page
        </Button>,
        onRetry && (
          <Button onClick={onRetry} size="medium" variant="secondary-stroke" key="retry">
            Retry
          </Button>
        ),
      ].filter(Boolean)}
      note={<ErrorNote error={error} itemKey={sectionKey} />}
    />
  );
}
